module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "roomChange"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v("个人信息")]), _vm._v(" "), _c('div', {
    staticClass: "padding-20 bg-fff"
  }, [_c('div', {
    staticClass: "listBox"
  }, [_c('div', {
    staticClass: "mesList"
  }, [_c('div', {
    staticClass: "title color-333 font-size-14px margin-top-8"
  }, [_vm._v("姓名：" + _vm._s(_vm.item.reporterName))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("上网账号：" + _vm._s(_vm.item.reporterNumber))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("联系电话：" + _vm._s(_vm.item.reporterPhone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("报修信息")]), _vm._v(" "), _c('div', {
    staticClass: "padding-20 bg-fff"
  }, [_c('div', {
    staticClass: "listBox"
  }, [_c('div', {
    staticClass: "mesList"
  }, [_c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("报修类型：" + _vm._s(_vm.item.reportType))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("报修位置：" + _vm._s(_vm.item.location))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("报修时间：" + _vm._s(_vm.item.reportTime))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("报修原因：" + _vm._s(_vm.item.reportCause))]), _vm._v(" "), (_vm.item.reportCauseDescription) ? _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("故障描述：" + _vm._s(_vm.item.reportCauseDescription))]) : _vm._e()])])]), _vm._v(" "), (_vm.item.repairerName) ? _c('div', [_c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("维修师傅")]), _vm._v(" "), _c('div', {
    staticClass: "padding-20 bg-fff"
  }, [_c('div', {
    staticClass: "listBox"
  }, [_c('div', {
    staticClass: "mesList"
  }, [_c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("网络维修人员：" + _vm._s(_vm.item.repairerName))]), _vm._v(" "), _c('p', {
    staticClass: "color-666 font-size-26 margin-top-8"
  }, [_vm._v("联系电话：" + _vm._s(_vm.item.repairerPhone))])])])])]) : _vm._e(), _vm._v(" "), (_vm.item.slips && _vm.item.slips.length > 0) ? _c('div', [_c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("报修流水")]), _vm._v(" "), _c('div', {
    staticClass: "padding-20 bg-fff"
  }, [_c('div', {
    staticClass: "case-details"
  }, [_c('div', {
    staticClass: "case-list"
  }, _vm._l((_vm.item.slips), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.slipType))]), _vm._v(" "), _c('div', {
      staticClass: "showitem"
    }, [_c('h4', [_vm._v(_vm._s(item.slipTime))]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.content))])])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), (_vm.item.buttons && _vm.item.buttons.length > 0) ? _c('div', {
    staticClass: "grid bg-appStyle color-fff footer"
  }, [_c('div', {
    staticClass: "gridWarp nopadding noborder"
  }, _vm._l((_vm.item.buttons), function(btnItem, key) {
    return _c('div', {
      key: key,
      staticClass: "gridCell",
      on: {
        "click": function($event) {
          return _vm.closeItem($event, btnItem, _vm.item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(btnItem) + "\n      ")])
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b7312a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RepairApplyDetial.vue
// module id = 839
// module chunks = 1